<template>
  <div
    ref="mapContainer"
    class="map-locations"
  />
</template>

<script>
import MixinGoogleMaps from '@/mixins/MixinGoogleMaps'

export default {
  mixins: [
    MixinGoogleMaps,
  ],
  props: {
		id: String,
    locations: {
      type: Array,
      default: () => []
    },
    mapClass: String,
		mapAttributes: {
			type: Object,
			default: () => ({})
		},
		clusterer: Boolean
  },
  data() {
    return {
      loaded: false,
      loading: false,
      locationToggle: true,
      mapElementClass: this.mapClass ?? 'map-locations__map',
      mapElementAttributes: this.mapAttributes ?? {},
			useClusterer: !!this.clusterer
    }
  },
  async mounted() {
    this.loading = true;
    try {
      await this.setupGoogleMaps()
    } catch(err) {
      this.isDebug() && console.error(err)
    }
    this.loading = false;
    this.loaded = true;
  }
}
</script>
